'use client';
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast:
            'cn-toast border-none! ' +
            'data-[type=success]:!bg-[#22C55E] ' +
            'data-[type=warning]:!bg-[#F59E0B] ' +
            'data-[type=error]:!bg-[#EF4444] ' +
            'data-[type=info]:!bg-[#ccc]/50',
          icon: 'text-white!',
          title: 'text-white!',
          description: 'text-white!',
        },
      }}
      {...props}
    />
  );
};
export { Toaster };
